import { SET_PAGE, SET_ROWS_PER_PAGE, INIT_PAGE } from './types/index';

export const updatePage = page => async dispatch => {
  dispatch({ type: SET_PAGE, payload: page });
};
export const updateRowPerPage = rowsPerPage => async dispatch => {
  dispatch({ type: SET_ROWS_PER_PAGE, payload: rowsPerPage });
};
export const initPage = rowsPerPage => async dispatch => {
  dispatch({ type: INIT_PAGE, payload: rowsPerPage });
};
